import React from "react";
import styles from "./team.module.css";
import Image1 from "../../../../../assests/advisor/profil1.png";
import Image2 from "../../../../../assests/advisor/fahinur.png";
import Image3 from "../../../../../assests/advisor/alam_ashraful.jpg";
import { useEffect, useRef, useState } from "react";

const TeamInfo = [
  {
    image: Image3,
    name: "Alam Ashraful",
    company: "Business Corners SAS",
    position: "Co-Founder, Corporate Director, COO",
    paragraph:
      "“Our mission is to empower businesses by connecting buyers, suppliers, and products, driving sustainable growth in complex markets.”",
    email: "asraf@businesscorners.online",
  },
  {
    image: Image1,
    name: "Haque Mohammed",
    company: "Business Corners SAS",
    position: "Founder, Chairman, CEO",
    paragraph:
      "“Success in business is about creating synergy between people, products, and markets. At Business Corner, we turn connections into opportunities.”",
    email: "mohammed@businesscorners.online",
  },
  {
    image: Image2,
    name: "Haque Fahinur",
    company: "Business Corners SAS",
    position: "Co-Founder, Managing Director, CMO & CTO",
    paragraph:
      "“We believe well-connected business ecosystems drive global success. At Business Corner, we offer tools, networks, and expertise to achieve it.”",
    email: "fahinur@businesscorners.online",
  },
];

function Team() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.team_wrapper}>
      <div id="team" className={styles.team_container}>
        <div className={styles.teamHeading}>
          <h2
            ref={pRef}
            className={`${styles.teamHeadingh2} ${
              isVisible ? styles.show : ""
            }`}>
            Our Team Leader
          </h2>
          <h3
            ref={pRef}
            className={`${styles.teamHeadingh3} ${
              isVisible ? styles.show : ""
            }`}>
            Meet a Crew of Professionals
          </h3>
          <div className={styles.teamLine}></div>
        </div>
        <div
          ref={pRef}
          className={`${styles.teamCardWrapper} ${
            isVisible ? styles.show : ""
          }`}>
          <div className={styles.teamInfo}>
            <img
              className={styles.teamProfil}
              src={TeamInfo[0].image}
              alt="advisor"
            />
            <h3 className={styles.teamText}>{TeamInfo[0].name}</h3>
            <h4 className={styles.teamText}>{TeamInfo[0].company}</h4>
            <h5 className={styles.teamText}>{TeamInfo[0].position}</h5>
            <p className={styles.teamText}>{TeamInfo[0].paragraph}</p>
          </div>
          <div className={styles.teamInfo}>
            <img
              className={styles.teamProfil}
              src={TeamInfo[1].image}
              alt="advisor"
            />
            <h3 className={styles.teamText}>{TeamInfo[1].name}</h3>
            <h4 className={styles.teamText}>{TeamInfo[1].company}</h4>
            <h5 className={styles.teamText}>{TeamInfo[1].position}</h5>
            <p className={styles.teamText}>{TeamInfo[1].paragraph}</p>
          </div>
          <div className={styles.teamInfo}>
            <img
              className={styles.teamProfil}
              src={TeamInfo[2].image}
              alt="advisor"
            />
            <h3 className={styles.teamText}>{TeamInfo[2].name}</h3>
            <h4 className={styles.teamText}>{TeamInfo[2].company}</h4>
            <h5 className={styles.teamText}>{TeamInfo[2].position}</h5>
            <p className={styles.teamText}>{TeamInfo[2].paragraph}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
